import { GetListParams, UpdateParams } from 'react-admin';
import { CustomDataProvider, registerModuleDataProvider } from '../../../providers/CustomDataProvider';
import { listChainConfigs, updateChainConfig } from '../../../services/xpxPerpsChainTokenConfigService';

const resourceName = 'xpx-perps/chain-token-config/chains';

export const xpxPerpsChainConfigsDataProvider: CustomDataProvider = {
  async getList(_resource: string, _params: GetListParams): Promise<any> {
    const response = await listChainConfigs();
    const items: any[] = response.data?.items ?? [];
    return {
      data: items.map((item) => ({ ...item, id: item.chainId })),
      total: items.length,
    };
  },

  async update(_resource: string, params: UpdateParams): Promise<any> {
    const { id, data } = params;
    await updateChainConfig(Number(id), data.depositEnabled, data.withdrawalEnabled);
    return { data: { ...data, id } };
  },
};

registerModuleDataProvider(resourceName, xpxPerpsChainConfigsDataProvider);
